import { http } from '../utils/http';
import Pagination from '../interfaces/common/pagination';
import Paging from '../interfaces/common/paging';
import SortFormatterUtils from '../utils/sortFormatterUtils';
import ReconcileStatus from '../interfaces/output/reconcileStatus';

export default class ReconcileStatusApi {
    static fetchReconcileStatusById = async(reconcileStatusId: string): Promise<ReconcileStatus> => {
        const { data } = await http.get<ReconcileStatus>(`ordersource/${reconcileStatusId}`);

        return data;
    };

    static fetchReconcileStatuses = async(paging: Paging): Promise<Pagination<ReconcileStatus>> => {
        const url = SortFormatterUtils.addSortingToUrl(paging, null, '/reconcileStatus');

        const { data } = await http.get<Pagination<ReconcileStatus>>(url);

        return data;
    };
}
